import { Outlet } from "react-router-dom";
import CockpitLayout from "../../domain/cockpit/layout/CockpitLayout";
import CockpitSideTabs from "../../domain/cockpit/layout/CockpitSideTabs";
import { useIsModuleEnabled } from "../../domain/platform_core/feature_flags/services/FeatureFlagService";
import ModuleLockedLayout from "../../domain/platform_core/funnel/components/ModuleLockedLayout";
import ServerUnavailable from "../../domain/platform_core/shell/components/ServerUnavailable";

export default function CockpitPage() {
  const { isEnabled, isLoading, isError, isRetrying, retry } =
    useIsModuleEnabled("cockpit");

  // Keine Cockpit-Inhalte rendern, solange der Modulstatus nicht feststeht.
  if (isLoading) return null;
  if (isError) return <ServerUnavailable onRetry={retry} isRetrying={isRetrying} />;

  if (!isEnabled) {
    return (
      <ModuleLockedLayout
        moduleId="cockpit"
        moduleName="Cockpit"
        fallbackDescription="Projekte und Anlagen steuern"
      />
    );
  }

  return (
    <CockpitLayout sidebar={<CockpitSideTabs />}>
      <Outlet />
    </CockpitLayout>
  );
}
